import React from "react";
import { Check } from "lucide-react";
import { cn } from "../../lib/utils";

const ColorSelector = ({ colors, value, onChange }) => (
  <div>
    <div className="mb-3">
      <span className="label-mono">Color {value ? `· ${value}` : ""}</span>
    </div>
    <div className="flex flex-wrap gap-2.5" data-testid="color-selector">
      {colors.map((c) => {
        const active = value === c.name;
        const isLight = ["#F5F5F0", "#E7E1D3"].includes(c.hex.toUpperCase());
        return (
          <button
            key={c.name}
            onClick={() => onChange(c.name)}
            aria-pressed={active}
            aria-label={c.name}
            title={c.name}
            data-testid={`color-option-${c.name.toLowerCase()}`}
            className={cn(
              "relative flex h-9 w-9 items-center justify-center rounded-full transition-transform duration-150 hover:scale-105",
              active ? "ring-2 ring-ink ring-offset-2 ring-offset-paper" : "ring-1 ring-ink/20"
            )}
            style={{ backgroundColor: c.hex }}
          >
            {active && (
              <Check size={16} className={isLight ? "text-ink" : "text-paper"} />
            )}
          </button>
        );
      })}
    </div>
  </div>
);

export default ColorSelector;
